export const NEW_ENTITY_ID = 'new-entity';
export const DEFAULT_GET_DATA_INTERVAL = 60000;
export const DRAWER_DEFAULT_DIRECTION = 'rtl';
export const DRAWER_DEFAULT_SIZE = '480px';
export const DEFAULT_PRICE_DELIMITER = ' ';
export const VOTP_INPUT_LENGTH = 6;
export const CASH_GET_DATA_INTERVAL = 20000;
export const BIOMATERIAL_BAR_CODE_HEIGHT = 19;
